import React, { Component } from 'react';

class DateTime extends Component {
    constructor(props) {
        super(props);

        this.state = {
            tiempo: new Date(props.initialTime),
            interval: null
        }
    }

    componentDidMount() {
        this.setTimer();
    }

    componentWillUnmount() {
        this.setState({
            interval: clearInterval(this.state.interval)
        });
    }

    setTimer() {
        this.setState({
            interval: setInterval(() => {
                this.tick();
            }, 1000)
        });
    }

    tick() {
        let oldTime = new Date(this.state.tiempo);

        let newTime = new Date(oldTime.setSeconds(oldTime.getSeconds() + 1));
        this.setState({ tiempo: newTime });
    }

    render() {
        return (
            <div>
                <span className="ti-time portico"></span>
                <span className="span-color-top-bar">{(this.state.tiempo) ? this.state.tiempo.toLocaleString() : this.state.tiempo}</span>
            </div>
        );
    }
}

export default DateTime;


// WEBPACK FOOTER //
// ./Portico/App/Screens/MenuProductos/components/DateTime.jsx